module.exports = __webpack_public_path__ + "static/41c8162d-c2a6-49b0-8139-8bebab187588-06671499059eb42232f314e93c47eb52.woff2";